import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import {
  MAX_DIAS_RANGO,
  validarRango,
  consultarRecuperaciones,
  exportarRecuperacionesExcel,
  mensajeError,
} from "./reporteRecuperacionesGps.utils";

// Modal para generar el reporte de recuperaciones de GPS directamente a Excel
const ReporteRecuperacionesGpsModal = ({ show, onHide }) => {
  const [fechaInicio, setFechaInicio] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));
  const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
  const [generando, setGenerando] = useState(false);

  const generar = async () => {
    const error = validarRango(fechaInicio, fechaFin);
    if (error) {
      NotificationManager.warning(error, "Reporte de recuperaciones");
      return;
    }
    setGenerando(true);
    try {
      const data = await consultarRecuperaciones(fechaInicio, fechaFin);
      if (data.length === 0) {
        NotificationManager.info("No hay recuperaciones en el rango seleccionado", "Reporte de recuperaciones");
        return;
      }
      exportarRecuperacionesExcel(data, fechaInicio, fechaFin);
      NotificationManager.success(data.length + " recuperaciones exportadas", "Reporte de recuperaciones");
      onHide();
    } catch (err) {
      NotificationManager.error(mensajeError(err), "Reporte de recuperaciones");
      console.log(err);
    } finally {
      setGenerando(false);
    }
  };

  return (
    // El style neutraliza la regla global .modal de ReportesMaersk/styles.css (fondo blanco a pantalla completa)
    <Modal
      show={show}
      onHide={generando ? undefined : onHide}
      centered
      style={{ backgroundColor: "transparent", maxHeight: "none", borderRadius: 0, boxShadow: "none" }}
    >
      <Modal.Header className="d-flex align-items-center justify-content-between">
        <Modal.Title>Reporte de recuperaciones de GPS</Modal.Title>
        {/* Botón propio: .btn-close de react-bootstrap no tiene estilos en Tabler y .close agrega un ícono extra */}
        <button
          type="button"
          aria-label="Cerrar"
          onClick={onHide}
          disabled={generando}
          style={{
            background: "transparent",
            border: 0,
            padding: 0,
            color: "#cd201f",
            fontSize: "1.75rem",
            fontWeight: 700,
            lineHeight: 1,
            cursor: generando ? "not-allowed" : "pointer",
            opacity: generando ? 0.5 : 1,
          }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-6">
            <label>Fecha inicio</label>
            <input
              className="form-control"
              type="date"
              value={fechaInicio}
              max={fechaFin}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>
          <div className="col-6">
            <label>Fecha fin</label>
            <input
              className="form-control"
              type="date"
              value={fechaFin}
              min={fechaInicio}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>
        </div>
        <small className="text-muted">Rango máximo de {MAX_DIAS_RANGO} días.</small>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={generando}>
          Cancelar
        </Button>
        <Button variant="success" onClick={generar} disabled={generando}>
          <i className="fa fa-file-excel-o" /> {generando ? "Generando..." : "Generar Excel"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReporteRecuperacionesGpsModal;
